import * as React from "react";
import { SVGProps, memo } from "react";

const SvgInformation = (props: SVGProps<SVGSVGElement>) => (
  <svg width={26} height={26} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.5 13c0 5.799-4.701 10.5-10.5 10.5S2.5 18.799 2.5 13 7.201 2.5 13 2.5 23.5 7.201 23.5 13Zm2.5 0c0 7.18-5.82 13-13 13S0 20.18 0 13 5.82 0 13 0s13 5.82 13 13ZM14.5 7.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM13 10.75c.69 0 1.25.56 1.25 1.25v6.5a1.25 1.25 0 1 1-2.5 0V12c0-.69.56-1.25 1.25-1.25Z"
      fill="#046CC2"
    />
  </svg>
);

const Memo = memo(SvgInformation);

export default Memo;
